import type { DynamicTableProps, autoColsItem } from "../dynamic-table";
import { type TablePaginationConfig } from "ant-design-vue/es/table";
import type { orderParamaItem, optionItem } from "../types/table";
import type { TableColumn } from "../types";
import type { cloumnFilterItem } from "../dynamic-table";
import { isArray, isBoolean } from "@/utils/is";

interface scroll {
  x?: string | number | boolean;
  y?: string | number | boolean;
}

export const changeFormat = (filterVal: Object, props: DynamicTableProps) => {
  for (const i in filterVal) {
    const val = filterVal[i];
    for (const j in props.columnFilter) {
      const item = props.columnFilter[j];
      if (typeof item == "object") {
        if (item.prop == i) {
          //目前先仅仅处理number
          if (item.dataType == "number") {
            if (val != null && val != undefined && val != "")
              filterVal[i] = parseFloat(val);
          }
          break;
        }
      }
    }
  }
  return filterVal;
};

export const queryParamAdapter = (
  queryParams: object,
  props: DynamicTableProps,
  pageOption: TablePaginationConfig | undefined | false,
  type?: String
) => {
  switch (props.remoteQueryMode) {
    case 0:
      return hgAdapter(); //化工数据请求模式
    case 1:
      return wmsAdapter(queryParams, pageOption, type); //仓库数据请求模式1   type参数用来确定是否获取全部数据
    case 2:
      return wmsAdapter(queryParams, pageOption, type); //仓库数据请求模式2
    case 3:
      return mesAdapter(queryParams, pageOption, type); //新平台Mes数据请求格式
  }

  function hgAdapter() {
    /* 构建动态查询参数
             格式 query={"PageSize":0,"Page":0,"Conditions":[{"Key":"Code","Value":"string"}]}
    */
    const autoParams = {
      query: {
        Page: 0,
        PageSize: 10,
        Conditions: [] as any[],
        LoginUser: "",
      },
    };
    autoParams.query.Conditions = [];
    //添加分页信息
    if (!Object.is(pageOption, false)) {
      if (pageOption) {
        autoParams.query.Page = pageOption.current ? pageOption.current : 1;
        autoParams.query.PageSize = pageOption.pageSize
          ? pageOption.pageSize
          : 10;
      }
    }
    //排除掉null,undefined,''的参数
    for (const i in queryParams) {
      const paramVal = queryParams[i];
      if (i == "undefined" || !i) continue;
      if (!paramVal) {
        if (typeof paramVal == "function") continue;
        if (typeof paramVal == "string" && paramVal == "") continue;
        const para = {
          Key: i,
          Value: queryParams[i],
        };
        autoParams.query.Conditions.push(para);
      }
    }
    //把query参数变为json类型
    const parama = {
      query: JSON.stringify(autoParams.query),
    };
    //返回拼接过的字符串
    return parama;
  }

  function wmsAdapter(queryParams, pageOption, type?: String) {
    const temp = {
      Page: 1,
      PageSize: type ? 0 : 10,
    };
    debugger
    const autoParams = { ...temp, ...queryParams };
    //添加分页信息
    if (!Object.is(pageOption, false)) {
      if (pageOption) {
        autoParams.Page = type
          ? 0
          : pageOption.current
            ? pageOption.current
            : 1;
        autoParams.PageSize = type
          ? 0
          : pageOption.pageSize
            ? pageOption.pageSize
            : 10;
      }
    }
    return autoParams;
  }

  function mesAdapter(queryParams, pageOption, type?: String) {
    const temp = {
      Request: {
        Page: 1,
        PageSize: 10,
      },
    };
    debugger
    const autoParams = {
      Request: { Page: 0, PageSize: 0 },
    };
    Object.assign(autoParams, queryParams);
    autoParams.Request = { ...temp.Request, ...queryParams.Request };
    //添加分页信息
    if (!Object.is(pageOption, false)) {
      if (pageOption) {
        autoParams.Request.Page = type
          ? 0
          : pageOption.current
            ? pageOption.current
            : 1;
        autoParams.Request.PageSize = type
          ? 0
          : pageOption.pageSize
            ? pageOption.pageSize
            : 10;
      }
    } else {
      autoParams.Request.Page = 0;
      autoParams.Request.PageSize = 0;
    }
    return autoParams;
  }
};

//获取排序数据
export const getOrderParama = (props: DynamicTableProps) => {
  let tempArray = [] as orderParamaItem[];
  if (props.OrderParam) {
    tempArray = tempArray.concat(props.OrderParam);
  }
  return tempArray;
};

//函数用于根据数据，对滚动位置进行计算
export const setScrollPosition = function (
  props: DynamicTableProps,
  scroolHeight?: number
) {
  let scrollTemp = {
    x: 0,
  } as scroll;
  if (props.scroll) {
    scrollTemp = props.scroll;
  } else {
    scrollTemp.x = "max-content"; //默认自适应宽度 先不计算横向滚动宽度
    if (scroolHeight) {
      scrollTemp.y = scroolHeight;
    }
  }
  // console.log('计算得到的滚动宽度为：' + scrollTemp.x);
  return scrollTemp;
};

export const GuidID = function () {
  //生成GUIID
  let guid = "";
  for (let i = 1; i <= 32; i++) {
    const n = Math.floor(Math.random() * 16.0).toString(16);
    guid += n;
    if (i == 8 || i == 12 || i == 16 || i == 20) guid += "-";
  }
  return guid;
};

export const getFixedCols = function (
  cols: TableColumn[] | autoColsItem[] | undefined
) {
  //在丢到数据中显示之前，将列重新排序
  let target = [] as TableColumn[];
  if (typeof cols != "undefined") {
    const fixedLeftCols = cols.filter((item) => {
      return item.fixed == "left" || item.fixed == true;
    });
    const fixedRightCols = cols.filter((item) => {
      return item.fixed == "right";
    });
    const commonCols = cols.filter((item) => {
      return typeof item.fixed == "undefined" || item.fixed == false;
    });
    target = fixedLeftCols.concat(commonCols).concat(fixedRightCols);
  }
  return target;
};

// const setOperatrBtn = (record, col, emit, locale) => {
//   const btnClick = (key) => {
//     //key的作用是用来识别是哪个按钮事件
//     emit("on-btn-click", record, col, key);
//   };

//   return (
//     <span>
//       {col.btnOption.map((items) => {
//         //生成下拉选项
//         return (
//           <a-button
//             size="small"
//             type={items.type}
//             title={locale.value == "zh" ? items.tooltipZH : items.tooltipEN}
//             label={locale.value == "zh" ? items.labelZH : items.labelEN}
//             style={"color:" + items.color}
//             onClick={btnClick.bind(this, items.btnKey)}
//           >
//             {items.icon ? <em class={items.icon}></em> : ""}
//             {items.label ? (
//               <label>
//                 {locale.value == "zh" ? items.labelZH : items.labelEN}
//               </label>
//             ) : (
//               ""
//             )}
//           </a-button>
//         );
//       })}
//     </span>
//   );
// };

export const formatQueryParama2 = (
  queryOrderParam,
  filterParmas,
  props,
  complexQueryCondition,
  queryParams
) => {
  const remoteTemp2 = {
    Conditions: [] as optionItem[],
    OrderParam: [] as orderParamaItem[],
  };

  if (queryOrderParam.length) {
    remoteTemp2.OrderParam = queryOrderParam;
  }
  const tempFilter2 = {} as optionItem;
  Object.entries(filterParmas).forEach(([key, value]) => {
    tempFilter2.Key = key;
    tempFilter2.Value = value as string;
    const copy1 = {} as optionItem;
    $.extend(true, copy1, tempFilter2);
    let filterItem = {} as cloumnFilterItem;
    for (let k = 0; k < props.columnFilter.length; k++) {
      const field = props.columnFilter[k];
      if (typeof field == "object") {
        if (field.prop == key) {
          filterItem = field;
        }
        break;
      } else if (typeof field == "string") {
        if (field == key) {
          filterItem.prop = field;
          break;
        }
      }
    }
    if (isArray(copy1.Value)) {
      //兼容多选情况
      copy1.MatchCase = "In";
      copy1.Value = copy1.Value.join(";"); //将数组转换成字符串
    } else if (isBoolean(copy1.Value)) {
      //如果类型是bool的话，则默认使用equal
      copy1.MatchCase = "Equal";
    } else {
      copy1.MatchCase = filterItem.MatchCase ? filterItem.MatchCase : "Like";
    }

    remoteTemp2.Conditions.push(copy1);
  });
  if (isArray(complexQueryCondition)) {
    const complex = complexQueryCondition;
    remoteTemp2.Conditions = Object.assign(remoteTemp2.Conditions, complex);
  }
  //remoteTemp2.Conditions = remoteTemp2.Conditions.concat(complexQueryCondition) //将高级查询组件的数据拼接进来
  let targetCondition = remoteTemp2.Conditions;
  //@ts-ignore
  if (queryParams.Conditions)
    //@ts-ignore
    targetCondition = remoteTemp2.Conditions.concat(queryParams?.Conditions);

  Object.assign(remoteTemp2, queryParams);
  remoteTemp2.Conditions = targetCondition;
  return remoteTemp2;
};

export const formatQueryParama3 = (
  queryOrderParam,
  filterParmas,
  props,
  complexQueryCondition,
  queryParams
) => {
  //查询模式为3的时候，参数整合
  const remoteTemp3 = {
    Request: {
      Conditions: [] as optionItem[],
      OrderParam: [] as orderParamaItem[],
    },
  };
  // debugger
  if (queryOrderParam.length) {
    remoteTemp3.Request.OrderParam = queryOrderParam;
  }
  const tempFilter3 = {} as optionItem;
  Object.entries(filterParmas).forEach(([key, value]) => {
    tempFilter3.Key = key;
    tempFilter3.Value = value as string;
    const copy1 = {} as optionItem;
    $.extend(true, copy1, tempFilter3);
    let tempItem = {} as cloumnFilterItem;

    for (let m = 0; m < props.columnFilter.length; m++) {
      const field = props.columnFilter[m];
      if (typeof field == "object") {
        if (field.prop == key) {
          tempItem = field;
        }
        break;
      } else if (typeof field == "string") {
        if (field == key) {
          tempItem.prop = field;
          break;
        }
      }
    }
    if (isArray(copy1.Value)) {
      //兼容多选情况
      copy1.MatchCase = "In";
      copy1.Value = copy1.Value.join(";"); //将数组转换成字符串
    } else if (isBoolean(copy1.Value)) {
      //如果类型是bool的话，则默认使用equal
      copy1.MatchCase = "Equal";
    } else {
      copy1.MatchCase = tempItem.MatchCase ? tempItem.MatchCase : "Like";
    }
    remoteTemp3.Request.Conditions.push(copy1);
  });

  let tempCondition3 = remoteTemp3.Request.Conditions
    ? remoteTemp3.Request.Conditions
    : [];
  //@ts-ignore
  if (queryParams.Request)
    if (isArray(queryParams.Request.Conditions)) {
      //@ts-ignore
      tempCondition3 = remoteTemp3.Request.Conditions.concat(
        queryParams.Request.Conditions
      );
    }

  if (isArray(complexQueryCondition)) {
    const complex = complexQueryCondition;
    remoteTemp3.Request.Conditions = Object.assign(
      remoteTemp3.Request.Conditions,
      complex
    );
    //remoteTemp3.Request.Conditions = remoteTemp3.Request.Conditions.concat(complexQueryCondition)//将复杂条件合并到数组中，优先级以复杂条件为准
  }

  Object.assign(remoteTemp3, queryParams);
  remoteTemp3.Request.Conditions = tempCondition3;
  return remoteTemp3;
};

//冒泡排序法，用于数字类型排序
export const bubbleSort = function (arr: Array<number>): Array<number> {
  const final: Array<number> = new Array(...arr);
  for (let i = 0; i < final.length; i++) {
    let no_swap = true;
    for (let j = 0; j < final.length - i - 1; j++) {
      // 如果前一个更大，则和后面的交换
      if (final[j] > final[j + 1]) {
        const temp = final[j + 1];
        final[j + 1] = final[j];
        final[j] = temp;
        no_swap = false;
      }
    }
    // 如果未冒泡，则已经排序完毕
    if (no_swap) {
      break;
    }
  }
  return final;
};

export const getVisiCols = function (Cols?: autoColsItem[]) {
  if (Cols) {
    return Cols.filter((item) => {
      return item.Visible == true;
    });
  } else {
    return [];
  }
};

// 处理时间格式的公共方法
export const getLocalDate = function (value, showTime?: boolean) {
  if (value == null) {
    return null;
  }
  const dt = new Date(value);
  const y = dt.getUTCFullYear();
  const m = (dt.getUTCMonth() + 1 + "").padStart(2, "0");
  const d = (dt.getUTCDate() + "").padStart(2, "0");
  const hh = (dt.getUTCHours() + "").padStart(2, "0");
  const mm = (dt.getUTCMinutes() + "").padStart(2, "0");
  const ss = (dt.getUTCSeconds() + "").padStart(2, "0");
  return showTime ? `${y}-${m}-${d} ${hh}:${mm}:${ss}` : `${y}-${m}-${d}`;
};

export const getBaseUrlInfo = function () {
  //根据配置文件，获取系统的基础URL信息
  let baseURL = "";
  if (
    LtConfig.baseURL == undefined ||
    LtConfig.baseURL == null ||
    LtConfig.baseURL == ""
  ) {
    baseURL =
      window.location.protocol +
      "//" +
      window.location.hostname +
      ":" +
      location.port;
  } else {
    if (LtConfig.baseURL.indexOf("http") == -1) {
      baseURL = "http://" + LtConfig.baseURL + ":" + LtConfig.port;
    } else {
      baseURL = LtConfig.baseURL + ":" + LtConfig.port;
    }
  }
  // return 'http://220.176.20.59:8283'
  return baseURL;
};